<template>
  <div>
    <!-- Camera stream beside what the gate shows: the site's signage, or a
         storage gate's kiosk. -->
    <div class="mb-2 flex w-[800px] gap-4">
      <div class="h-72 w-auto">
        <CameraStreamTab :camera="camera" />
      </div>

      <KioskViewFrame v-if="kioskLane" :lane="kioskLane" class="shrink-0" />
      <div
        v-else-if="camera.signageIdentity && camera.type !== 'exit'"
        class="h-72 overflow-hidden rounded-lg border"
        :style="{
          aspectRatio:
            camera.signageViewName === 'lady_margarets_park'
              ? '16 / 9'
              : '9 / 16',
        }"
      >
        <iframe
          :src="`/screen/?identity=${camera.signageIdentity}`"
          class="scale-16 h-[625%] w-[625%] origin-top-left transform border-0"
          title="Site Signage"
          loading="lazy"
        />
      </div>
    </div>

    <!-- ANPR + barrier control on one line. The switch is NetFM staff only
         (not is_superuser: CAMC head office are superusers); CAMC users see
         the read-only status. -->
    <div class="flex items-center justify-between gap-4">
      <CameraAnprControlItem v-if="isNetfmStaff" :camera="camera" />
      <CameraAnprStatusItem v-else :camera="camera" />
      <BarrierControlItem
        v-if="camera.barrier"
        compact
        :barrier="camera.barrier"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { type Camera } from "@/services/cameras/listCameras";
import { type StorageLane } from "@/services/storage/storage";

defineProps<{ camera: Camera; kioskLane?: StorageLane | null }>();

const { currentUser } = useCurrentUser();
const isNetfmStaff = computed(
  () => currentUser.value?.email.toLowerCase().endsWith("@netfm.org") ?? false,
);
</script>
